import {
  Body2,
  Box,
  Button,
  ButtonGroup,
  ButtonGroupSection,
  Display3,
  Modal,
} from '@sainsburys-tech/fable'
import React from 'react'

const AlertMixStatusModal = ({
  isOpened,
  setIsOpened,
  message,
}: {
  isOpened: boolean
  setIsOpened: React.Dispatch<React.SetStateAction<boolean>>
  message: string
}) => (
  <Box padding={{ md: 'sm' }} className='c-common-modal'>
    <Modal
      isOpen={isOpened}
      onClose={() => setIsOpened(false)}
      testid='alert-mix-status-modal'
    >
      <Display3>Information</Display3>
      <Body2>{message}</Body2>
      <ButtonGroup>
        <ButtonGroupSection>
          <Button
            onClick={() => setIsOpened(false)}
            testid='alert-mix-status-ok'
          >
            OK
          </Button>
        </ButtonGroupSection>
      </ButtonGroup>
    </Modal>
  </Box>
)

export default AlertMixStatusModal
